// src/views/unidades/UnidadeModal.jsx
import React, { useState, useEffect } from "react";
import vinculosService from "../../services/vinculosService";
import condominosService from "../../services/condominosService";
import unidadesService from "../../services/unidadesService";
import { getApiBaseUrl } from "../../services/apiBase";
import ConfirmModal from "../../components/ui/ConfirmModal";

const fmtPhone=v=>{const d=v.replace(/\D/g,"").slice(0,11);return d.length<=10?d.replace(/^(\d{2})(\d{4})(\d{0,4})/,"($1) $2-$3").trim():d.replace(/^(\d{2})(\d{5})(\d{0,4})/,"($1) $2-$3").trim();};
const fmtDt=dt=>{if(!dt)return"-";try{return new Date((String(dt||"").split("T")[0])+"T12:00:00").toLocaleDateString("pt-BR");}catch{return dt;}};
const emailValido=v=>!v||/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);

// Contato (email/telefone) da unidade foi descontinuado.
// Fonte de verdade:
//   - Padrão: condominos.email / .celular / .nrWhatsApp
//   - Override por unidade: unidade_vinculos.email
//
// Endereço da unidade também foi descontinuado: o endereço físico é
// = endereço do condomínio + bloco + número da unidade. Para boleto,
// o endereço usado é o do condômino (condominos.cep, logradouro, etc.).
const EMPTY={
  idCondominio:"",unidade:"",bloco:"",areM2:"",fracaoIdeal:"",fracaoIdealSindico:"",
  vlrDifCondominio:"0.00",vlrFundoReserva:"0.00",vlrCondProporcional:"0.00",
  diaVencimentoDif:"",permReservAreaLocacao:"Sim",cobFundoReserva:"Sim",
  pgFundReserva:"Proprietario",geraCondominio:"Sim",
  observacao:"",qtdPessoas:"",
};

const EMPTY_VINCULO={idCondomino:"",tpVinculo:"Proprietario",respBoleto:"Proprietario",email:"",dtInicio:"",observacao:""};
const EMPTY_INATIVAR={dtFim:"",observacao:""};

export default function UnidadeModal({show,onClose,onSave,editData,saving=false,idCondominio,condominioNome="",serverError=null}){
  const isEdit=!!editData?.id;
  const [form,setForm]=useState(EMPTY);
  const [errors,setErrors]=useState({});
  const [tab,setTab]=useState("unidade");
  // Vínculos
  const [vinculos,setVinculos]=useState([]);
  const [unidadeStatus, setUnidadeStatus] = useState(null); // null | 'checking' | 'ok' | 'duplicado'
  const [unidadeDupId,  setUnidadeDupId]  = useState(null);
  const [condominos,setCondominos]=useState([]);
  const [showNovoVinculo,setShowNovoVinculo]=useState(false);
  const [novoVinculo,setNovoVinculo]=useState(EMPTY_VINCULO);
  const [editVinculo,setEditVinculo]=useState(null);
  const [inativarTarget,setInativarTarget]=useState(null);
  const [inativarForm,setInativarForm]=useState(EMPTY_INATIVAR);
  const [savingVinc,setSavingVinc]=useState(false);
  const [loadingVinculos,setLoadingVinculos]=useState(false);
  // Veículos / PETs
  const [veiculos,setVeiculos]=useState([]);
  const [pets,setPets]=useState([]);
  const [novoVeiculo,setNovoVeiculo]=useState({idCondomino:"",descVeiculo:"",placa:"",modelo:"",cor:"",tpVeiculo:"Carro"});
  const [novoPet,setNovoPet]=useState({idCondomino:"",nmPet:"",especie:"Cachorro",raca:"",cor:"",porte:"Pequeno",observacao:""});
  const [savingVeic,setSavingVeic]=useState(false);
  const [savingPet,setSavingPet]=useState(false);
  // Histórico
  const [historico,setHistorico]=useState([]);

  useEffect(()=>{
    // Condôminos são globais por cliente — sempre carregar independente do condomínio
    condominosService.listarSelect().then(r=>setCondominos(r.data||[])).catch(()=>{});
  },[]);

  // Recarrega dados da unidade ao abrir ou trocar de aba
  const carregarDadosUnidade = (id) => {
    setLoadingVinculos(true);
    vinculosService.listar(id).then(r=>setVinculos(r.data||[])).catch(()=>setVinculos([])).finally(()=>setLoadingVinculos(false));
    unidadesService.listarVeiculos(id).then(r=>setVeiculos(r.data||[])).catch(()=>setVeiculos([]));
    unidadesService.listarPets(id).then(r=>setPets(r.data||[])).catch(()=>setPets([]));
    fetch(`${getApiBaseUrl()}/unidades/${id}/historico`)
      .then(r=>r.json()).then(r=>setHistorico(r.data||[])).catch(()=>setHistorico([]));
  };

  useEffect(()=>{
    if(!show)return;
    const base=editData?{...EMPTY,...editData}:{...EMPTY,idCondominio};
    setForm(base);setErrors({});setTab("unidade");
    setShowNovoVinculo(false);setNovoVinculo(EMPTY_VINCULO);setEditVinculo(null);setInativarTarget(null);
    if(editData?.id){
      carregarDadosUnidade(editData.id);
    }else{setVinculos([]);setVeiculos([]);setPets([]);setHistorico([]);}
    setNovoVeiculo({descVeiculo:"",placa:"",modelo:""});
    setNovoPet({descPet:"",raca:"",porte:"Pequeno"});
    setUnidadeStatus(null); setUnidadeDupId(null);
    setUnidadeStatus(null);
  },[show,editData,idCondominio]);



  // Recarrega vínculos toda vez que o usuário clica na aba Condôminos
  useEffect(()=>{
    if(tab==="vinculos" && editData?.id){
      setLoadingVinculos(true);
      vinculosService.listar(editData.id)
        .then(r=>setVinculos(r.data||[]))
        .catch(()=>setVinculos([]))
        .finally(()=>setLoadingVinculos(false));
    }
  },[tab, editData]);

  const set=(f,v)=>{setForm(p=>({...p,[f]:v}));setErrors(p=>({...p,[f]:undefined}));};
  const setV=(f,v)=>setNovoVinculo(p=>({...p,[f]:v}));

  const validate=()=>{
    const e={};
    if(!form.unidade.toString().trim()) e.unidade="O número da unidade é obrigatório";
    setErrors(e);
    if(Object.keys(e).length){
      setTab(e.unidade?"unidade":"unidade");
      return false;
    }
    return true;
  };
  const handleSave=()=>{
    if(unidadeStatus==="duplicado") return; // erro já visível
    if(validate())onSave({...form,id:editData?.id});
  };

  // Verificação de duplicidade de unidade em tempo real
  const verificarUnidade = async (unidade, bloco) => {
    if (!idCondominio || !unidade?.trim()) return;
    setUnidadeStatus("checking");
    try {
      const r = await unidadesService.verificar({
        idCondominio,
        unidade: unidade.trim(),
        bloco: bloco?.trim() || "",
        excludeId: editData?.id || "",
      });
      if (r.disponivel === false) {
        setUnidadeStatus("duplicado");
        setUnidadeDupId(r.duplicado?.id || null);
      } else {
        setUnidadeStatus("ok");
        setUnidadeDupId(null);
      }
    } catch { setUnidadeStatus(null); }
  };

  // Pré-preenche o email do novo vínculo a partir do condômino selecionado
  // (apenas como dica/override — o backend já trata fallback para c.email).
  const handleCondominoSelect=(id,setter)=>{
    setter(p=>({...p,idCondomino:id}));
    if(id){const c=condominos.find(x=>String(x.id)===String(id));if(c?.email)setter(p=>({...p,email:c.email}));}
  };

  // Mensagem inline para abas (substitui alerts)
  const [tabError, setTabError] = useState(null);
  const showTabError = (msg) => { setTabError(msg); setTimeout(()=>setTabError(null), 4500); };
  const [confirmacao, setConfirmacao] = useState(null);
  const askConfirm = (opts) => new Promise(resolve => setConfirmacao({ ...opts, resolve }));

  // Salvar novo vínculo
  const handleSalvarVinculo=async()=>{
    if(!novoVinculo.idCondomino) return showTabError("Selecione o condômino.");
    if(!novoVinculo.dtInicio)    return showTabError("Informe a data de início.");
    if(novoVinculo.email && !emailValido(novoVinculo.email)) return showTabError("E-mail do vínculo inválido.");
    setSavingVinc(true);
    try{
      const r=await vinculosService.criar({...novoVinculo,idUnidade:editData.id});
      setVinculos(p=>[r.data,...p]);
      setShowNovoVinculo(false);setNovoVinculo(EMPTY_VINCULO);
    }catch(e){showTabError(e.message);}
    setSavingVinc(false);
  };

  // Salvar edição de vínculo
  const handleSalvarEdicao=async()=>{
    if(editVinculo.email && !emailValido(editVinculo.email)) return showTabError("E-mail inválido.");
    setSavingVinc(true);
    try{
      const r=await vinculosService.atualizar(editVinculo.id,{respBoleto:editVinculo.respBoleto,email:editVinculo.email,observacao:editVinculo.observacao});
      setVinculos(p=>p.map(v=>v.id===editVinculo.id?r.data:v));
      setEditVinculo(null);
    }catch(e){showTabError(e.message);}
    setSavingVinc(false);
  };

  // Inativar vínculo
  const handleInativar=async()=>{
    if(!inativarForm.dtFim) return showTabError("Informe a data de desativação.");
    setSavingVinc(true);
    try{
      await vinculosService.inativar(inativarTarget.id,inativarForm);
      setVinculos(p=>p.map(v=>v.id===inativarTarget.id?{...v,ativo:0,dtFim:inativarForm.dtFim}:v));
      setInativarTarget(null);setInativarForm(EMPTY_INATIVAR);
    }catch(e){showTabError(e.message);}
    setSavingVinc(false);
  };

  // Veículos
  const addVeiculo=async()=>{
    if(!novoVeiculo.placa.trim()) return showTabError("Informe a placa do veículo.");
    setSavingVeic(true);
    try{
      const r=await unidadesService.criarVeiculo({...novoVeiculo,idUnidade:editData.id});
      setVeiculos(p=>[...p,r.data]);
      setNovoVeiculo({idCondomino:"",descVeiculo:"",placa:"",modelo:"",cor:"",tpVeiculo:"Carro"});
    }catch(e){showTabError(e.message);}
    setSavingVeic(false);
  };
  const delVeiculo=async(id)=>{
    const ok = await askConfirm({ titulo:"Excluir veículo?", mensagem:"Deseja realmente excluir este veículo?", textoOk:"Excluir", perigo:true });
    if(!ok) return;
    try{ await unidadesService.deletarVeiculo(id); setVeiculos(p=>p.filter(v=>v.id!==id)); }catch(e){ showTabError(e.message); }
  };
  const addPet=async()=>{
    if(!novoPet.nmPet.trim()) return showTabError("Informe o nome do PET.");
    setSavingPet(true);
    try{
      const r=await unidadesService.criarPet({...novoPet,idUnidade:editData.id});
      setPets(p=>[...p,r.data]);
      setNovoPet({idCondomino:"",nmPet:"",especie:"Cachorro",raca:"",cor:"",porte:"Pequeno",observacao:""});
    }catch(e){showTabError(e.message);}
    setSavingPet(false);
  };
  const delPet=async(id)=>{
    const ok = await askConfirm({ titulo:"Excluir PET?", mensagem:"Deseja realmente excluir este PET?", textoOk:"Excluir", perigo:true });
    if(!ok) return;
    try{ await unidadesService.deletarPet(id); setPets(p=>p.filter(pt=>pt.id!==id)); }catch(e){ showTabError(e.message); }
  };

  if(!show)return null;

  const vinculosAtivos=vinculos.filter(v=>v.ativo);
  const temProprietario=vinculosAtivos.some(v=>v.tpVinculo==="Proprietario");
  const temInquilino=vinculosAtivos.some(v=>v.tpVinculo==="Inquilino");

  const tabs=[
    {id:"unidade",  label:"Unidade",  icon:"bi-house"},
    {id:"vinculos", label:"Condôminos",icon:"bi-people",disabled:!isEdit,badge:vinculosAtivos.length},
    {id:"financeiro",label:"Financeiro",icon:"bi-cash-coin"},
    {id:"veiculos", label:"Veículos", icon:"bi-car-front",disabled:!isEdit,badge:veiculos.length},
    {id:"pets",     label:"PETs",     icon:"bi-heart",disabled:!isEdit,badge:pets.length},
    {id:"historico",label:"Histórico",icon:"bi-clock-history",disabled:!isEdit,badge:historico.length},
  ];

  return(
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}><i className="bi bi-house-add" style={{fontSize:18,color:"#fff"}}/></div>
              <div><h5 className="modal-title mb-0">{isEdit?"Editar Unidade":"Nova Unidade"}</h5><small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{condominioNome}</small></div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>
          <div style={{background:"var(--primary)",padding:"0 16px"}}>
            <ul className="nav nav-tabs border-0 flex-nowrap" style={{gap:2,overflowX:"auto"}}>
              {tabs.map(t=>(
                <li key={t.id} className="nav-item">
                  <button className={`nav-link border-0 d-flex align-items-center gap-1 ${tab===t.id?"active":""}`}
                    style={{background:tab===t.id?"#fff":"transparent",color:tab===t.id?"var(--primary)":"rgba(255,255,255,.7)",borderRadius:"6px 6px 0 0",fontFamily:"Poppins,sans-serif",fontSize:12,fontWeight:500,padding:"9px 12px",cursor:t.disabled?"not-allowed":"pointer",opacity:t.disabled?.55:1,whiteSpace:"nowrap"}}
                    onClick={()=>{
                      if(!t.disabled){
                        setTab(t.id);
                        // Força recarregamento ao entrar na aba Condôminos
                        if(t.id==="vinculos" && editData?.id){
                          setLoadingVinculos(true);
                          vinculosService.listar(editData.id)
                            .then(r=>setVinculos(r.data||[]))
                            .catch(()=>setVinculos([]))
                            .finally(()=>setLoadingVinculos(false));
                        }
                      }
                    }} title={t.disabled?"Salve a unidade primeiro":""}>
                    <i className={`bi ${t.icon}`}/>{t.label}
                    {t.badge>0&&<span style={{background:t.id==="historico"?"#F59E0B":"var(--accent)",color:"#fff",borderRadius:10,padding:"0 5px",fontSize:10,fontWeight:700,marginLeft:2}}>{t.badge}</span>}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body">

            {(serverError || tabError) && (
              <div className="alert alert-danger d-flex justify-content-between align-items-start" style={{fontSize:13}}>
                <span><i className="bi bi-exclamation-triangle-fill me-2"/>{serverError || tabError}</span>
                <button type="button" className="btn-close" onClick={()=>{ setTabError(null); }}/>
              </div>
            )}

            {/* ── UNIDADE ── */}
            {tab==="unidade"&&(
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-house"/> Dados da Unidade</div>
                  <div className="row g-3">
                    <div className="col-md-2"><label className="form-label">Unidade <span className="required-mark">*</span></label>
                      <input
        className={`form-control ${errors.unidade||unidadeStatus==="duplicado"?"is-invalid":unidadeStatus==="ok"?"is-valid":""}`}
        value={form.unidade}
        onChange={e=>{set("unidade",e.target.value);setUnidadeStatus(null);}}
        onBlur={e=>verificarUnidade(e.target.value, form.bloco)}
        placeholder="Ex: 101"/>
                      {errors.unidade&&<div className="invalid-feedback">{errors.unidade}</div>}
                      {unidadeStatus==="duplicado"&&<div className="invalid-feedback" style={{display:"block"}}>
                        <i className="bi bi-exclamation-triangle-fill me-1"/>
                        Unidade {form.unidade}{form.bloco?` / Bloco ${form.bloco}`:""} já existe neste condomínio.
                      </div>}
                      {unidadeStatus==="ok"&&<div className="valid-feedback" style={{display:"block"}}>
                        <i className="bi bi-check-circle-fill me-1"/>Unidade disponível.
                      </div>}
                      {unidadeStatus==="checking"&&<div className="form-text text-muted">
                        <span className="spinner-border spinner-border-sm me-1"/>Verificando...
                      </div>}
                    </div>
                    <div className="col-md-2"><label className="form-label">Bloco</label><input className="form-control" value={form.bloco} onChange={e=>set("bloco",e.target.value)}
                        onBlur={e=>verificarUnidade(form.unidade, e.target.value)} placeholder="Ex: A"/></div>
                    <div className="col-md-2"><label className="form-label">Área (m²)</label><input className="form-control" type="number" step="0.01" value={form.areM2} onChange={e=>set("areM2",e.target.value)}/></div>
                    <div className="col-md-3"><label className="form-label">Fração Ideal</label><input className="form-control" type="number" step="0.000001" value={form.fracaoIdeal} onChange={e=>set("fracaoIdeal",e.target.value)}/></div>
                    <div className="col-md-3"><label className="form-label">Fração Ideal Síndico</label><input className="form-control" type="number" step="0.000001" value={form.fracaoIdealSindico} onChange={e=>set("fracaoIdealSindico",e.target.value)}/></div>
                    <div className="col-md-3"><label className="form-label">Qtd. Pessoas</label><input className="form-control" type="number" min="0" value={form.qtdPessoas} onChange={e=>set("qtdPessoas",e.target.value)}/></div>
                    <div className="col-md-3"><label className="form-label">Vencimento Dif.</label><input className="form-control" type="number" min="1" max="28" placeholder="Dia" value={form.diaVencimentoDif} onChange={e=>set("diaVencimentoDif",e.target.value)}/></div>
                  </div>
                </div>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-info-circle"/> Observação Geral</div>
                  <div className="row g-3">
                    <div className="col-12">
                      <textarea className="form-control" rows={2} value={form.observacao||""} onChange={e=>set("observacao",e.target.value)} placeholder="Observações internas (não exibidas ao condômino)"/>
                      <div className="form-text" style={{fontSize:11,marginTop:6}}>
                        <i className="bi bi-lightbulb me-1"/>
                        <strong>E-mail / WhatsApp:</strong> ficam no cadastro do <strong>Condômino</strong> (fonte padrão) e podem ser sobrescritos por unidade na aba <strong>Vínculos</strong> abaixo.
                      </div>
                      <div className="form-text" style={{fontSize:11,marginTop:4}}>
                        <i className="bi bi-geo-alt me-1"/>
                        <strong>Endereço da unidade:</strong> = endereço do <strong>Condomínio</strong> + bloco e número da unidade. Para envio de boleto/correspondência, o endereço usado é o do <strong>Condômino</strong>.
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-toggles"/> Configurações</div>
                  <div className="row g-3">
                    {[{label:"Perm. Reserva Área",field:"permReservAreaLocacao",opts:[["Sim","Sim"],["Nao","Não"]]},{label:"Cobra Fundo Reserva",field:"cobFundoReserva",opts:[["Sim","Sim"],["Nao","Não"]]},{label:"Responsável Fundo",field:"pgFundReserva",opts:[["Proprietario","Proprietário"],["Inquilino","Inquilino"]]},{label:"Gera Condomínio",field:"geraCondominio",opts:[["Sim","Sim"],["Nao","Não"]]}].map(({label,field,opts})=>(
                      <div className="col-md-3" key={field}><label className="form-label">{label}</label>
                        <select className="form-select" value={form[field]} onChange={e=>set(field,e.target.value)}>{opts.map(([v,l])=><option key={v} value={v}>{l}</option>)}</select>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}

            {/* ── VÍNCULOS ── */}
            {tab==="vinculos"&&(
              <div className="form-section">
                <div className="form-section-title d-flex justify-content-between align-items-center">
                  <span><i className="bi bi-people"/> Condôminos / Inquilinos Vinculados</span>
                  {!showNovoVinculo&&!editVinculo&&!inativarTarget&&(
                    <button className="btn btn-success btn-sm" onClick={()=>setShowNovoVinculo(true)}>
                      <i className="bi bi-plus-lg"/> Novo Vínculo
                    </button>
                  )}
                </div>

                {/* Regras visuais */}
                <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
                  <span style={{background:temProprietario?"#DCFCE7":"var(--gray-100)",color:temProprietario?"#166534":"var(--gray-400)",padding:"3px 12px",borderRadius:20,fontSize:12,fontWeight:600}}>
                    <i className={`bi bi-${temProprietario?"check":"circle"}-circle me-1`}/>Proprietário: {temProprietario?"1 ativo":"Vago"}
                  </span>
                  <span style={{background:temInquilino?"#DCFCE7":"var(--gray-100)",color:temInquilino?"#166534":"var(--gray-400)",padding:"3px 12px",borderRadius:20,fontSize:12,fontWeight:600}}>
                    <i className={`bi bi-${temInquilino?"check":"circle"}-circle me-1`}/>Inquilino: {temInquilino?"1 ativo":"Nenhum"}
                  </span>
                </div>

                {/* Painel: contato efetivo para envio */}
                {(() => {
                  const respAtivo = vinculosAtivos.find(v=>v.respBoleto==="Proprietario") || vinculosAtivos.find(v=>v.respBoleto==="Inquilino") || vinculosAtivos[0];
                  const emailEf = respAtivo?.emailEfetivo || respAtivo?.email || respAtivo?.emailCondomino || null;
                  const waEf = respAtivo?.nrWhatsApp || respAtivo?.celular || null;
                  if (!respAtivo) return null;
                  return (
                    <div style={{background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:"10px 12px",marginBottom:14,fontSize:12.5}}>
                      <div style={{fontWeight:600,color:"var(--primary)",marginBottom:4}}>
                        <i className="bi bi-send-check me-1"/>Contato efetivo para envio (boletos / comunicados)
                      </div>
                      <div style={{display:"flex",gap:18,flexWrap:"wrap",color:"var(--gray-700)"}}>
                        <span>
                          <i className="bi bi-envelope-check me-1"/>
                          {emailEf
                            ? <strong style={{color:"#166534"}}>{emailEf}</strong>
                            : <span style={{color:"#B91C1C"}}>Sem e-mail (boletos não serão enviados)</span>}
                        </span>
                        <span>
                          <i className="bi bi-whatsapp me-1" style={{color:"#25D366"}}/>
                          {waEf
                            ? <strong style={{color:"#166534"}}>{waEf}</strong>
                            : <span style={{color:"#B91C1C"}}>Sem WhatsApp</span>}
                        </span>
                      </div>
                    </div>
                  );
                })()}

                {/* Form novo vínculo */}
                {showNovoVinculo&&(
                  <div style={{background:"var(--bg-success-soft)",border:"1px solid #BBF7D0",borderRadius:8,padding:16,marginBottom:16}}>
                    <div style={{fontWeight:600,color:"#166534",fontSize:13,marginBottom:12}}><i className="bi bi-plus-circle me-2"/>Novo Vínculo</div>
                    <div className="row g-2">
                      <div className="col-md-5"><label className="form-label" style={{fontSize:12}}>Condômino <span className="required-mark">*</span></label>
                        <select className="form-select form-select-sm" value={novoVinculo.idCondomino} onChange={e=>handleCondominoSelect(e.target.value,setNovoVinculo)}>
                          <option value="">— Selecione —</option>
                          {condominos.map(c=><option key={c.id} value={c.id}>{c.nmCompleto} — {c.cpf_cnpj}</option>)}
                        </select>
                      </div>
                      <div className="col-md-3"><label className="form-label" style={{fontSize:12}}>Tipo <span className="required-mark">*</span></label>
                        <select className="form-select form-select-sm" value={novoVinculo.tpVinculo} onChange={e=>setV("tpVinculo",e.target.value)}>
                          {!temProprietario&&<option value="Proprietario">Proprietário</option>}
                          {!temInquilino&&<option value="Inquilino">Inquilino</option>}
                          {temProprietario&&temInquilino&&<option disabled>Todos os tipos já estão ativos</option>}
                        </select>
                      </div>
                      <div className="col-md-2"><label className="form-label" style={{fontSize:12}}>Dt. Início <span className="required-mark">*</span></label>
                        <input type="date" className="form-control form-control-sm" value={novoVinculo.dtInicio} onChange={e=>setV("dtInicio",e.target.value)}/>
                      </div>
                      <div className="col-md-2"><label className="form-label" style={{fontSize:12}}>Resp. Boleto</label>
                        <select className="form-select form-select-sm" value={novoVinculo.respBoleto} onChange={e=>setV("respBoleto",e.target.value)}>
                          <option value="Proprietario">Proprietário</option><option value="Inquilino">Inquilino</option>
                        </select>
                      </div>
                      <div className="col-md-5">
                        <label className="form-label" style={{fontSize:12}}>
                          E-mail específico desta unidade <span style={{fontWeight:400,color:"var(--gray-500)"}}>(opcional)</span>
                        </label>
                        <input className="form-control form-control-sm" type="email"
                          value={novoVinculo.email}
                          onChange={e=>setV("email",e.target.value)}
                          placeholder={(condominos.find(x=>String(x.id)===String(novoVinculo.idCondomino))?.email) || "Se vazio, usa o e-mail do condômino"}/>
                        <div style={{fontSize:10,color:"var(--gray-500)",marginTop:2}}>
                          <i className="bi bi-info-circle me-1"/>
                          Sobrescreve o e-mail apenas para esta unidade. Se vazio, usa o e-mail cadastrado no condômino.
                        </div>
                      </div>
                      <div className="col-md-5"><label className="form-label" style={{fontSize:12}}>Observação</label>
                        <input className="form-control form-control-sm" value={novoVinculo.observacao} onChange={e=>setV("observacao",e.target.value)}/>
                      </div>
                      <div className="col-md-2 d-flex align-items-end gap-1">
                        <button className="btn btn-success btn-sm flex-fill" onClick={handleSalvarVinculo} disabled={savingVinc||temProprietario&&temInquilino}>
                          {savingVinc?<span className="spinner-border spinner-border-sm"/>:<i className="bi bi-check-lg"/>}
                        </button>
                        <button className="btn btn-outline-secondary btn-sm" onClick={()=>{setShowNovoVinculo(false);setNovoVinculo(EMPTY_VINCULO);}}><i className="bi bi-x"/></button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Form edição */}
                {editVinculo&&(
                  <div style={{background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:16,marginBottom:16}}>
                    <div style={{fontWeight:600,color:"var(--primary)",fontSize:13,marginBottom:12}}><i className="bi bi-pencil me-2"/>Editando: {editVinculo.nmCompleto}</div>
                    <div className="row g-2">
                      <div className="col-md-3"><label className="form-label" style={{fontSize:12}}>Resp. Boleto</label>
                        <select className="form-select form-select-sm" value={editVinculo.respBoleto} onChange={e=>setEditVinculo(p=>({...p,respBoleto:e.target.value}))}>
                          <option value="Proprietario">Proprietário</option><option value="Inquilino">Inquilino</option>
                        </select>
                      </div>
                      <div className="col-md-4">
                        <label className="form-label" style={{fontSize:12}}>
                          E-mail desta unidade <span style={{fontWeight:400,color:"var(--gray-500)"}}>(opcional)</span>
                        </label>
                        <input className="form-control form-control-sm"
                          value={editVinculo.email||""}
                          onChange={e=>setEditVinculo(p=>({...p,email:e.target.value}))}
                          placeholder={editVinculo.emailCondomino || "Se vazio, usa o e-mail do condômino"}/>
                        <div style={{fontSize:10,color:"var(--gray-500)",marginTop:2}}>
                          {editVinculo.emailCondomino && (
                            <><i className="bi bi-info-circle me-1"/>E-mail do condômino: <code>{editVinculo.emailCondomino}</code></>
                          )}
                        </div>
                      </div>
                      <div className="col-md-3"><label className="form-label" style={{fontSize:12}}>Observação</label>
                        <input className="form-control form-control-sm" value={editVinculo.observacao||""} onChange={e=>setEditVinculo(p=>({...p,observacao:e.target.value}))}/>
                      </div>
                      <div className="col-md-2 d-flex align-items-end gap-1">
                        <button className="btn btn-primary btn-sm flex-fill" onClick={handleSalvarEdicao} disabled={savingVinc}>{savingVinc?<span className="spinner-border spinner-border-sm"/>:<i className="bi bi-check-lg"/>}</button>
                        <button className="btn btn-outline-secondary btn-sm" onClick={()=>setEditVinculo(null)}><i className="bi bi-x"/></button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Form inativar */}
                {inativarTarget&&(
                  <div style={{background:"#FFF7ED",border:"1px solid #FED7AA",borderRadius:8,padding:16,marginBottom:16}}>
                    <div style={{fontWeight:600,color:"#C2410C",fontSize:13,marginBottom:12}}><i className="bi bi-x-circle me-2"/>Inativar: {inativarTarget.nmCompleto} ({inativarTarget.tpVinculo==="Inquilino"?"Inquilino":"Proprietário"})</div>
                    <div className="row g-2 align-items-end">
                      <div className="col-md-3"><label className="form-label" style={{fontSize:12}}>Data de Desativação <span className="required-mark">*</span></label>
                        <input type="date" className="form-control form-control-sm" value={inativarForm.dtFim} onChange={e=>setInativarForm(p=>({...p,dtFim:e.target.value}))}/>
                      </div>
                      <div className="col-md-5"><label className="form-label" style={{fontSize:12}}>Motivo</label>
                        <input className="form-control form-control-sm" value={inativarForm.observacao} onChange={e=>setInativarForm(p=>({...p,observacao:e.target.value}))} placeholder="Ex: Fim de contrato, venda..."/>
                      </div>
                      <div className="col-md-2 d-flex gap-1">
                        <button className="btn btn-danger btn-sm flex-fill" onClick={handleInativar} disabled={savingVinc}>{savingVinc?<span className="spinner-border spinner-border-sm"/>:"Confirmar"}</button>
                        <button className="btn btn-outline-secondary btn-sm" onClick={()=>{setInativarTarget(null);setInativarForm(EMPTY_INATIVAR);}}><i className="bi bi-x"/></button>
                      </div>
                    </div>
                  </div>
                )}

                {/* Lista de vínculos */}
                {loadingVinculos
                  ? <div style={{textAlign:"center",padding:"32px 0"}}><span className="spinner-border spinner-border-sm text-primary me-2"/>Carregando vínculos...</div>
                  : vinculos.length===0
                  ? <div style={{textAlign:"center",color:"var(--gray-400)",padding:"32px 0"}}>
                      <i className="bi bi-people" style={{fontSize:32,display:"block",marginBottom:8}}/>
                      <p style={{fontSize:14,marginBottom:8}}>Nenhum vínculo cadastrado</p>
                      <button className="btn btn-outline-secondary btn-sm" onClick={()=>{
                        if(editData?.id){
                          setLoadingVinculos(true);
                          vinculosService.listar(editData.id).then(r=>setVinculos(r.data||[])).catch(()=>setVinculos([])).finally(()=>setLoadingVinculos(false));
                        }
                      }}><i className="bi bi-arrow-clockwise me-1"/>Recarregar</button>
                    </div>
                  : <table className="table table-custom">
                    <thead><tr><th>Condômino</th><th>Tipo</th><th>Resp. Boleto</th><th>E-mail</th><th>Início</th><th>Fim</th><th>Status</th><th style={{width:80}}>Ações</th></tr></thead>
                    <tbody>
                      {vinculos.map(v=>(
                        <tr key={v.id} style={{opacity:v.ativo?1:.6}}>
                          <td>
                            <div style={{fontWeight:600,fontSize:13}}>{v.nmCompleto}</div>
                            <div style={{fontSize:11,color:"var(--gray-400)"}}>{v.cpf_cnpj}</div>
                          </td>
                          <td><span style={{background:v.tpVinculo==="Inquilino"?"#FFF7ED":"#EFF6FF",color:v.tpVinculo==="Inquilino"?"#C2410C":"var(--primary)",padding:"2px 9px",borderRadius:12,fontSize:12,fontWeight:600}}>{v.tpVinculo==="Inquilino"?"Inquilino":"Proprietário"}</span></td>
                          <td style={{fontSize:12.5}}>{v.respBoleto==="Inquilino"?"Inquilino":"Proprietário"}</td>
                          <td style={{fontSize:12.5,color:"var(--gray-500)"}}>
                            {v.email
                              ? <span title="E-mail no vínculo (prioritário)" style={{color:"#166534",fontWeight:500}}><i className="bi bi-envelope-check me-1"/>{v.email}</span>
                              : v.emailCondomino
                                ? <span title="Usando e-mail do cadastro do condômino" style={{color:"var(--gray-600)"}}><i className="bi bi-person me-1"/>{v.emailCondomino}</span>
                                : <span style={{color:"#B91C1C"}}><i className="bi bi-envelope-slash me-1"/>—</span>}
                          </td>
                          <td style={{fontSize:12.5}}>{fmtDt(v.dtInicio)}</td>
                          <td style={{fontSize:12.5}}>{v.dtFim?fmtDt(v.dtFim):<span style={{color:"var(--gray-300)"}}>—</span>}</td>
                          <td>{v.ativo?<span className="badge-status badge-ativo"><i className="bi bi-circle-fill" style={{fontSize:7}}/>Ativo</span>:<span className="badge-status badge-inativo"><i className="bi bi-circle-fill" style={{fontSize:7}}/>Inativo</span>}</td>
                          <td>
                            <div className="table-actions">
                              {v.ativo && v.id && <>
                            <button className="btn btn-outline-secondary btn-sm btn-icon" title="Editar"
                              onClick={()=>{setEditVinculo({...v});setShowNovoVinculo(false);setInativarTarget(null);}}>
                              <i className="bi bi-pencil"/>
                            </button>
                            <button className="btn btn-outline-warning btn-sm btn-icon" title="Inativar"
                              style={{borderColor:"#F59E0B",color:"#B45309"}}
                              onClick={()=>{setInativarTarget(v);setShowNovoVinculo(false);setEditVinculo(null);}}>
                              <i className="bi bi-x-circle"/>
                            </button>
                          </>}
                          {v.legado && (
                            <span style={{fontSize:10,color:"var(--gray-400)",fontStyle:"italic"}}>legado</span>
                          )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                }
              </div>
            )}

            {/* ── FINANCEIRO ── */}
            {tab==="financeiro"&&(
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-cash-coin"/> Valores</div>
                <div className="row g-3">
                  {[{label:"Vlr. Dif. Condomínio (R$)",field:"vlrDifCondominio"},{label:"Vlr. Fundo de Reserva (R$)",field:"vlrFundoReserva"},{label:"Vlr. Cond. Proporcional (R$)",field:"vlrCondProporcional"}].map(({label,field})=>(
                    <div className="col-md-4" key={field}><label className="form-label">{label}</label>
                      <div className="input-group"><span className="input-group-text">R$</span><input className="form-control" type="number" step="0.01" min="0" value={form[field]} onChange={e=>set(field,e.target.value)}/></div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ── VEÍCULOS ── */}
            {tab==="veiculos"&&(
              <div className="form-section">
                <div className="form-section-title d-flex justify-content-between align-items-center">
                  <span><i className="bi bi-car-front"/> Veículos da Unidade</span>
                  <span style={{fontSize:11,fontWeight:400,color:"var(--gray-500)"}}>
                    <i className="bi bi-info-circle me-1"/>
                    Os próprios moradores também podem cadastrar pelo Portal do Condômino.
                  </span>
                </div>
                <div className="row g-2 mb-3 align-items-end">
                  <div className="col-md-3"><label className="form-label">Em nome de</label>
                    <select className="form-select form-select-sm" value={novoVeiculo.idCondomino}
                      onChange={e=>setNovoVeiculo(p=>({...p,idCondomino:e.target.value}))}>
                      <option value="">— Auto (proprietário da unidade) —</option>
                      {vinculosAtivos.map(v=>(
                        <option key={v.id} value={v.idCondomino}>
                          {v.nmCondomino || `Cond. #${v.idCondomino}`} ({v.tpVinculo})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2"><label className="form-label">Placa <span className="required-mark">*</span></label><input className="form-control" placeholder="ABC1D23" maxLength={8} value={novoVeiculo.placa} onChange={e=>setNovoVeiculo(p=>({...p,placa:e.target.value.toUpperCase()}))}/></div>
                  <div className="col-md-2"><label className="form-label">Tipo</label>
                    <select className="form-select" value={novoVeiculo.tpVeiculo} onChange={e=>setNovoVeiculo(p=>({...p,tpVeiculo:e.target.value}))}>
                      <option value="Carro">Carro</option>
                      <option value="Moto">Moto</option>
                      <option value="Bicicleta">Bicicleta</option>
                      <option value="Caminhao">Caminhão</option>
                      <option value="Outro">Outro</option>
                    </select>
                  </div>
                  <div className="col-md-2"><label className="form-label">Modelo</label><input className="form-control" placeholder="Ex: Corolla" value={novoVeiculo.modelo} onChange={e=>setNovoVeiculo(p=>({...p,modelo:e.target.value}))}/></div>
                  <div className="col-md-2"><label className="form-label">Cor</label><input className="form-control" placeholder="Prata" value={novoVeiculo.cor} onChange={e=>setNovoVeiculo(p=>({...p,cor:e.target.value}))}/></div>
                  <div className="col-md-1"><button className="btn btn-success w-100" onClick={addVeiculo} disabled={savingVeic}>{savingVeic?<span className="spinner-border spinner-border-sm"/>:<i className="bi bi-plus-lg"/>}</button></div>
                </div>
                {veiculos.length===0?<p style={{textAlign:"center",color:"var(--gray-400)",padding:"24px 0"}}>Nenhum veículo cadastrado</p>:
                  <table className="table table-custom">
                    <thead><tr><th style={{width:60}}>Foto</th><th>Placa</th><th>Tipo</th><th>Modelo</th><th>Cor</th><th>Dono</th><th style={{width:60}}>Ação</th></tr></thead>
                    <tbody>
                      {veiculos.map(v=>(
                        <tr key={v.id}>
                          <td>{v.foto?<img src={v.foto} alt="" style={{width:36,height:36,borderRadius:6,objectFit:"cover"}}/>:<i className="bi bi-car-front" style={{fontSize:20,color:"var(--gray-300)"}}/>}</td>
                          <td><span style={{fontFamily:"monospace",fontWeight:700,background:"var(--gray-100)",padding:"2px 8px",borderRadius:4}}>{v.placa||"-"}</span></td>
                          <td style={{fontSize:12.5}}>{v.tpveiculo||v.tpVeiculo||"-"}</td>
                          <td style={{fontSize:12.5}}>{v.modelo||v.descveiculo||v.descVeiculo||"-"}</td>
                          <td style={{fontSize:12.5}}>{v.cor||"-"}</td>
                          <td style={{fontSize:12,color:"var(--gray-600)"}}>{v.nmCondomino||v.nmcondomino||"—"}</td>
                          <td><button className="btn btn-outline-danger btn-sm btn-icon" onClick={()=>delVeiculo(v.id)}><i className="bi bi-trash3"/></button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>}
              </div>
            )}

            {/* ── PETs ── */}
            {tab==="pets"&&(
              <div className="form-section">
                <div className="form-section-title d-flex justify-content-between align-items-center">
                  <span><i className="bi bi-heart"/> PETs da Unidade</span>
                  <span style={{fontSize:11,fontWeight:400,color:"var(--gray-500)"}}>
                    <i className="bi bi-info-circle me-1"/>
                    Os próprios moradores também podem cadastrar pelo Portal do Condômino.
                  </span>
                </div>
                <div className="row g-2 mb-3 align-items-end">
                  <div className="col-md-3"><label className="form-label">Em nome de</label>
                    <select className="form-select form-select-sm" value={novoPet.idCondomino}
                      onChange={e=>setNovoPet(p=>({...p,idCondomino:e.target.value}))}>
                      <option value="">— Auto (proprietário da unidade) —</option>
                      {vinculosAtivos.map(v=>(
                        <option key={v.id} value={v.idCondomino}>
                          {v.nmCondomino || `Cond. #${v.idCondomino}`} ({v.tpVinculo})
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-2"><label className="form-label">Nome <span className="required-mark">*</span></label><input className="form-control" placeholder="Ex: Rex" value={novoPet.nmPet} onChange={e=>setNovoPet(p=>({...p,nmPet:e.target.value}))}/></div>
                  <div className="col-md-2"><label className="form-label">Espécie</label>
                    <select className="form-select" value={novoPet.especie} onChange={e=>setNovoPet(p=>({...p,especie:e.target.value}))}>
                      <option value="Cachorro">Cachorro</option>
                      <option value="Gato">Gato</option>
                      <option value="Ave">Ave</option>
                      <option value="Outro">Outro</option>
                    </select>
                  </div>
                  <div className="col-md-2"><label className="form-label">Raça</label><input className="form-control" value={novoPet.raca} onChange={e=>setNovoPet(p=>({...p,raca:e.target.value}))}/></div>
                  <div className="col-md-2"><label className="form-label">Porte</label><select className="form-select" value={novoPet.porte} onChange={e=>setNovoPet(p=>({...p,porte:e.target.value}))}><option value="Pequeno">Pequeno</option><option value="Medio">Médio</option><option value="Grande">Grande</option></select></div>
                  <div className="col-md-1"><button className="btn btn-success w-100" onClick={addPet} disabled={savingPet}>{savingPet?<span className="spinner-border spinner-border-sm"/>:<i className="bi bi-plus-lg"/>}</button></div>
                </div>
                {pets.length===0?<p style={{textAlign:"center",color:"var(--gray-400)",padding:"24px 0"}}>Nenhum PET cadastrado</p>:
                  <table className="table table-custom">
                    <thead><tr><th style={{width:60}}>Foto</th><th>Nome</th><th>Espécie</th><th>Raça</th><th>Porte</th><th>Dono</th><th style={{width:60}}>Ação</th></tr></thead>
                    <tbody>
                      {pets.map(p=>{
                        const porte = p.porte || "";
                        return (
                          <tr key={p.id}>
                            <td>{p.foto?<img src={p.foto} alt="" style={{width:36,height:36,borderRadius:6,objectFit:"cover"}}/>:<i className="bi bi-heart" style={{fontSize:18,color:"var(--gray-300)"}}/>}</td>
                            <td style={{fontWeight:600}}>{p.nmpet||p.nmPet||"-"}</td>
                            <td style={{fontSize:12.5}}>{p.especie||"-"}</td>
                            <td style={{fontSize:12.5}}>{p.raca||"-"}</td>
                            <td>{porte?<span style={{padding:"2px 10px",borderRadius:12,fontSize:12,fontWeight:600,background:porte==="Grande"?"#FFF7ED":porte==="Medio"?"#FFFBEB":"#EFF6FF",color:porte==="Grande"?"#C2410C":porte==="Medio"?"#92400E":"var(--primary)"}}>{porte==="Medio"?"Médio":porte}</span>:"-"}</td>
                            <td style={{fontSize:12,color:"var(--gray-600)"}}>{p.nmCondomino||p.nmcondomino||"—"}</td>
                            <td><button className="btn btn-outline-danger btn-sm btn-icon" onClick={()=>delPet(p.id)}><i className="bi bi-trash3"/></button></td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>}
              </div>
            )}

            {/* ── HISTÓRICO ── */}
            {tab==="historico"&&(
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-clock-history"/> Histórico de Vínculos</div>
                {historico.length===0?<p style={{textAlign:"center",color:"var(--gray-400)",padding:"32px 0"}}>Nenhum registro</p>:
                  <table className="table table-custom">
                    <thead><tr><th>Condômino</th><th>Tipo</th><th>Resp. Boleto</th><th>Entrada</th><th>Saída</th><th>Motivo</th></tr></thead>
                    <tbody>{historico.map(h=>(
                      <tr key={h.id} style={{background:!h.dtSaida?"#F0FDF4":""}}>
                        <td><div style={{fontWeight:600,fontSize:13}}>{h.nmCondomino||"-"}</div>{h.cpf_cnpj&&<div style={{fontSize:11,color:"var(--gray-400)"}}>{h.cpf_cnpj}</div>}</td>
                        <td><span style={{background:h.tpOcupacao==="Inquilino"?"#FFF7ED":"#EFF6FF",color:h.tpOcupacao==="Inquilino"?"#C2410C":"var(--primary)",padding:"2px 9px",borderRadius:12,fontSize:12,fontWeight:600}}>{h.tpOcupacao==="Inquilino"?"Inquilino":"Proprietário"}</span></td>
                        <td style={{fontSize:12.5}}>{h.respBoleto==="Inquilino"?"Inquilino":"Proprietário"}</td>
                        <td style={{fontSize:12.5}}>{fmtDt(h.dtEntrada)}</td>
                        <td>{h.dtSaida?<span style={{fontSize:12.5}}>{fmtDt(h.dtSaida)}</span>:<span style={{background:"var(--bg-success-soft)",color:"#166534",padding:"2px 8px",borderRadius:12,fontSize:11,fontWeight:600}}>● Atual</span>}</td>
                        <td style={{fontSize:12,color:"var(--gray-500)"}}>{h.motivoSaida||"-"}</td>
                      </tr>
                    ))}</tbody>
                  </table>
                }
              </div>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            {!isEdit?<div style={{fontSize:12,color:"var(--gray-400)"}}><i className="bi bi-info-circle me-1"/>Salve a unidade para gerenciar Condôminos, Veículos, PETs e Histórico</div>:<div/>}
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle"/> Cancelar</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving?<><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>:<><i className="bi bi-check-circle"/> {isEdit?"Salvar Alterações":"Cadastrar"}</>}</button>
            </div>
          </div>
        </div>
      </div>

      {confirmacao && (
        <ConfirmModal
          titulo={confirmacao.titulo}
          mensagem={confirmacao.mensagem}
          textoOk={confirmacao.textoOk}
          perigo={confirmacao.perigo}
          onConfirm={() => { confirmacao.resolve(true); setConfirmacao(null); }}
          onCancel={() => { confirmacao.resolve(false); setConfirmacao(null); }}
        />
      )}
    </div>
  );
}
